import BaseConfig from '@/config/base.js'

/** 根据 isRelease 取包对应页面域名：正式取 host 数组第一个，测试取最后一个 */
export function getPageHost(packageName) {
  const hosts = BaseConfig.apps[packageName]?.hosts
  if (!hosts || !hosts.length) {
    return ''
  }
  return BaseConfig.isRelease ? hosts[0] : hosts[hosts.length - 1]
}

/** 将相对路径或带域名的路径转为当前环境可用的 iframe src */
export function buildPageSrc(packageName, path) {
  if (!path) return ''

  const host = getPageHost(packageName)
  if (!host) return path

  if (path.startsWith('http://') || path.startsWith('https://')) {
    try {
      const url = new URL(path)
      url.protocol = 'https:'
      url.host = host
      return url.toString()
    } catch (err) {
      return path
    }
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `https://${host}${normalizedPath}`
}
